import { useEffect, useState } from "react";
import "./style.css";
import { useUserInfo } from "../../../../context/user";
import axios from "axios";
import DeleteFileModal from "../../../../components/DeleteFileModal";
import Uploadfile from "../../../../components/uploadFiles"; 
import AssistantMemory from "../../../../components/memory";
import env from "../../../../config/env"
import Icons from "../../../../components/icons";
import Plans from "../../../../components/Plans";
import { useAppServices } from "../../../../hook/services";
import SearchIcon from "@mui/icons-material/Search";
import NewAddWebsiteModal from "./component/NewAddWebsiteModal";
import toast from "react-hot-toast";
import { Tooltip } from "@mui/material";
import { format } from "date-fns";
import ResetContext from "../ResetContext";
import SharedKnowledge from "./component/SharedKnowledge";
import FilterDropdown from "./component/FilterDropdown";

const KB_TABS = ["Agent Knowledge", "Shared Knowledge", "Reset Context"];

function Files({ setActiveTab }) {
  const [activeKBTab, setActiveKBTab] = useState("Agent Knowledge");
  const BASE_URL = env.API_URL + "/v1";
  const userInfo = useUserInfo()[0];
  const AppService = useAppServices();
  const userActiveLocation = useUserInfo()[4];
  const [userFiles, setuserFiles] = useState();
  const [seletedFile, setSeletedFile] = useState();
  const [fileLoading, setFileLoading] = useState(false);
  const [downloadingFileId, setDownloadingFileId] = useState(null);
  const [memory, setMemory] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredFiles, setFilteredFiles] = useState([]);
  const [selectPlan, setSelectPlan] = useState();
  const [selectedItems, setSelectedItems] = useState([]);
  const [openWebModal, setOpenWebModal] = useState(false);
  const [pagination, setPagination] = useState({})
  const [agentFilter, setAgentFilter] = useState("");
  const [fileTypeFilter, setFileTypeFilter] = useState("");
  const [sharedRefresh, setSharedRefresh] = useState(0);

  const handleWebModal = () => setOpenWebModal(!openWebModal);


  const refreshFilesForActiveTab = () => {
    if (activeKBTab === "Shared Knowledge") {
      setSharedRefresh((n) => n + 1);
    } else {
      getuploadfiles();
    }
  };

  const getuploadfiles = async (page = 1) => {
    setFileLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/chat/assistants/files?profile_id=${userActiveLocation?.id}&user_id=${userInfo?._id}&page=${page}`
      );
      if (response) {
        setFileLoading(false);

        setuserFiles(response?.data?.data?.data);
        setPagination(response?.data?.pagination)
      }
    } catch (error) {
      toast.error(
        error?.message?.includes("400") ? "Files not found" : error.message
      );
      console.error("Error fetching files:", error);
    }
    setFileLoading(false);
  };

  const getMemory = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/chat/assistants/memory?profile_id=${userActiveLocation?.id}`
      );
      if (response) {
        setMemory(response?.data?.data?.data);
      }
    } catch (error) {
      return error;
    }
  };

  const updateMemory = async (content) => {
    let data = JSON.stringify({
      content: content,
    });

    try {
      const response = await axios.post(`${BASE_URL}/chat/assistants/memory`, {
        profile_id: userActiveLocation?.id,
        data: data,
      });
      if (response) {
        return response.data.data;
      }
    } catch (error) {
      return error?.response?.data;
    }
  };

  const deleteMemory = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL}/chat/assistants/memory/delete`,
        {
          profile_id: userActiveLocation?.id,
        }
      );
      if (response) {
        return response.data.data;
      }
    } catch (error) {
      return error;
    }
  };

  const refreshHandler = () => {
    getuploadfiles();
    getMemory();
  };

  useEffect(() => {
    refreshHandler();
  }, []);

  const confirmDelete = (fileInfo) => {
    setSeletedFile(fileInfo);
  };

  const deleteFile = async (fileIdsToDelete) => {
    try {
      const idsToDelete = seletedFile ? [seletedFile?.id] : fileIdsToDelete;

      setFileLoading(true);

      for (const fileId of idsToDelete) {
        const response = await axios.post(
          `${BASE_URL}/chat/assistants/files/delete`,
          {
            file_id: fileId,
          }
        );

        if (response) {
          setuserFiles((prevFiles) =>
            prevFiles.filter((file) => file.id !== fileId)
          );
        }
      }

      setFileLoading(false);

      setSeletedFile();
      setSelectedItems([]);
    } catch (error) {
      alert(error.response?.data?.err || "An error occurred during deletion.");
      setFileLoading(false);
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const applyFilters = (list) =>
    (list || []).filter((item) => {
      if (agentFilter && item.assistant_name !== agentFilter) return false;
      if (fileTypeFilter && item.name !== fileTypeFilter) return false;
      return true;
    });

  const filteredData = Array.isArray(userFiles)
    ? userFiles.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    : [];

  const totalPages = pagination?.total || 0
  const maxButtonsToShow = 5;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = applyFilters(searchQuery ? filteredFiles : filteredData)

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    if (pageNumber !== currentPage)
      getuploadfiles(pageNumber)
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      getuploadfiles(currentPage + 1)
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      getuploadfiles(currentPage - 1)
    }
  };

  const startPage = Math.max(currentPage - Math.floor(maxButtonsToShow / 2), 1);
  const endPage = Math.min(startPage + maxButtonsToShow - 1, totalPages);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    const filtered = userFiles.filter((file) => {
      const fileName = file.name ? file.name.toLowerCase() : "";
      const fileUsername = file.username ? file.username.toLowerCase() : "";
      return fileName.includes(query) || fileUsername.includes(query);
    });

    setFilteredFiles(filtered);
    setCurrentPage(1);
  };

  const handleCheckboxChange = (itemId) => {
    setSelectedItems((prevSelected) => {
      if (prevSelected.includes(itemId)) {
        return prevSelected.filter((id) => id !== itemId);
      } else {
        return [...prevSelected, itemId];
      }
    });
  };

  const handleDeleteSelected = () => {
    if (selectedItems.length === 0) {
      return;
    }
    deleteFile(selectedItems);
    setSelectedItems([]);
  };

  const handleDownloadFile = async (fileItem) => {
    setDownloadingFileId(fileItem.id);
    try {
      const win = window.open(`${BASE_URL}/chat/assistants/files/download?file_id=${fileItem?.id}&isStreaming=true`, '_blank')
      setTimeout(() => win.close(), 3000)
      setDownloadingFileId(null);
    } catch (error) {
      console.error("Error downloading file:", error.message);
      setDownloadingFileId(null);
    }
  };

  return (
    <div className="container-alignment">
      <div className="MuiBox-root css-1wwy5nw">
        <h1 className="headingpage-branding">Knowledge Base</h1>
      </div>

      <div
        style={{
          display: "flex",
          gap: "32px",
          borderBottom: "1px solid #E5E5E5",
          marginTop: "20px",
          marginBottom: "24px",
        }}
      >
        {KB_TABS.map((tab) => {
          const isActive = activeKBTab === tab;
          return (
            <button
              key={tab}
              type="button"
              onClick={() => setActiveKBTab(tab)}
              style={{
                background: "none",
                border: "none",
                padding: "12px 4px",
                fontSize: "15px",
                cursor: "pointer",
                color: isActive ? "#000" : "#757575",
                fontWeight: isActive ? 600 : 400,
                borderBottom: isActive
                  ? "2px solid #000"
                  : "2px solid transparent",
                marginBottom: "-1px",
              }}
            >
              {tab}
            </button>
          );
        })}
      </div>

      {activeKBTab === "Reset Context" && <ResetContext />}

      {activeKBTab === "Shared Knowledge" && (
        <SharedKnowledge
          onUpload={refreshHandler}
          onAddUrl={handleWebModal}
          refreshSignal={sharedRefresh}
        />
      )}

      {activeKBTab === "Agent Knowledge" && (
        <>
          <div>
            <p className="text-[18px]">Assign knowledge to one or more agents.</p>
            <p className="text-[16px] text-muted-foreground">Only selected agents will have access.</p>
          </div>
          <div className="first_box relative">
            <div className="search_box">
              <input
                type="text"
                className={`inputsearch ${memory ? "!w-[500px]" : "!w-[740px]"} `}
                placeholder="Search for Files"
                value={searchQuery}
                onChange={handleSearch}
              />

              <span className="absolute top-3 left-3">
                <SearchIcon />
              </span>
            </div>

            <div style={{ display: "flex", width: "50%", justifyContent: "end" }}>
              {memory && (
                <AssistantMemory
                  classname="filecogChatBtn"
                  refreshchat={getMemory}
                  updateMemory={updateMemory}
                  gettingmemory={memory}
                  refreshmemory={refreshHandler}
                  deleteMemory={deleteMemory}
                />
              )}
              <Uploadfile
                classname="filecogChatBtn"
                refreshchat={refreshHandler}
              />
              <button
                className="flex gap-2 items-center border !border-[#D9D9D9] shadow"
                onClick={handleWebModal}
                aria-label="Send message"
                style={{
                  padding: "5px 16px",
                  borderRadius: "5px",
                  cursor: "pointer",
                  marginLeft: "20px",
                }}
              >
                <Icons id="KBurl" />
                <span>Add URL</span>
              </button>
            </div>
          </div>

          <p style={{ fontWeight: 600, marginBottom: "8px", fontSize: "14px" }}>
            Filter by:
          </p>
          <div style={{ display: "flex", gap: "12px", marginBottom: "20px" }}>
            <FilterDropdown
              value={agentFilter}
              onChange={setAgentFilter}
              placeholder="All agents"
              options={[
                { value: "", label: "All agents" },
                ...Array.from(
                  new Set(
                    (userFiles || [])
                      .map((f) => f.assistant_name)
                      .filter(Boolean)
                  )
                ).map((name) => ({ value: name, label: name })),
              ]}
            />
            <FilterDropdown
              value={fileTypeFilter}
              onChange={setFileTypeFilter}
              placeholder="All files"
              options={[
                { value: "", label: "All files" },
                ...Array.from(
                  new Set(
                    (userFiles || []).map((f) => f.name).filter(Boolean)
                  )
                ).map((name) => ({ value: name, label: name })),
              ]}
            />
          </div>

          <button
            style={{
              backgroundColor: "#000",
              color: "#fff",
              borderRadius: "10px",
              padding: "10px 20px",
            }}
            onClick={handleDeleteSelected}
            disabled={selectedItems.length === 0}
          >
            Delete All
          </button>

          <div>
            <table style={{ width: "100%" }}>
              <div className="table_heading">
                <p
                  className="td_border"
                  style={{ padding: "18px", width: "6%", }}
                ></p>
                <p
                  className="td_border"
                  style={{ padding: "21px", width: "20%" }}
                >
                  File Name
                </p>

                <p
                  className="td_border"
                  style={{ padding: "21px", width: "20%" }}
                >
                  Agents
                </p>

                <p
                  className="td_border"
                  style={{ padding: "21px", width: "20%" }}
                >
                  Date Created
                </p>
                <p
                  className="td_border"
                  style={{ padding: "21px", width: "20%" }}
                >
                  Uploaded By
                </p>
                <p
                  className="td_border"
                  style={{ padding: "21px", width: "20%" }}
                ></p>
              </div>
              {fileLoading ? (
                <p align="center">Loading Files...</p>
              ) : (
                <>
                  {currentItems?.length > 0 ? (
                    currentItems.map((item, index) => (
                      <div
                        key={index}
                        className="table_body"
                        style={{ background: "#FFFFFF" }}
                      >
                        <p
                          className="td_border"
                          style={{ padding: "21px", margin: "2px" }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedItems.includes(item.id)}
                            onChange={() => handleCheckboxChange(item.id)}
                            style={{
                              width: "18px",
                              height: "18px",
                              accentColor: "#000",
                              cursor: "pointer",
                            }}
                          />
                        </p>

                        <Tooltip title={item.name} placement="top-start">
                          <p
                            className="td_border"
                            style={{ padding: "21px", width: "20%" }}
                          >
                            <span className="pr-2">
                              <Icons id="KBfile" />
                            </span>
                            {item.name.length > 15
                              ? item.name.slice(0, 15) + "..."
                              : item.name}
                          </p>
                        </Tooltip>

                        <p
                          className="td_border"
                          style={{ padding: "21px", width: "20%" }}
                        >
                          {item.assistant_name}
                        </p>

                        <p
                          className="td_border"
                          style={{ padding: "21px", width: "20%" }}
                        >
                          {format(new Date(item?.created_at), "dd/MM/yyyy")}
                        </p>
                        <p
                          className="td_border"
                          style={{ padding: "21px", width: "20%" }}
                        >
                          {item.username}
                        </p>
                        <p
                          className="td_border"
                          style={{
                            padding: "21px",
                            width: "20%",
                            paddingRight: "35px",
                            textAlign: "right",
                            display: "flex",
                            justifyContent: "right",
                            alignItems: "center",
                          }}
                        >
                          <button
                            onClick={() => {
                              handleDownloadFile(item);
                            }}
                            disabled={
                              downloadingFileId !== null &&
                              downloadingFileId !== item.id
                            }
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: downloadingFileId
                                ? "not-allowed"
                                : "pointer",
                              width: "20px",
                              height: "20px",
                              marginRight: "8px",
                            }}
                          >
                            {downloadingFileId === item.id ? (
                              <Icons id="spinner" color="black" />
                            ) : (
                              <Icons id="downloadFile" />
                            )}
                          </button>

                          <button
                            onClick={() => confirmDelete(item)}
                            style={{
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                            }}
                          >
                            <Icons id="delete" />
                          </button>
                        </p>
                      </div>
                    ))
                  ) : (
                    <p align="center">No files found.</p>
                  )}
                </>
              )}
            </table>
          </div>

          {/* Pagination Controls */}
          {!fileLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <button
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
                style={{
                  padding: "8px 16px",
                  margin: "0 5px",
                  backgroundColor: "white",
                  color: "black",
                  border: "1px solid black",
                  borderRadius: "4px",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  opacity: currentPage === 1 ? 0.6 : 1,
                }}
              >
                Previous
              </button>

              {[...Array(endPage - startPage + 1)].map((_, index) => {
                const pageNumber = startPage + index;
                return (
                  <button
                    key={pageNumber}
                    onClick={() => handlePageChange(pageNumber)}
                    style={{
                      padding: "8px 16px",
                      margin: "0 5px",
                      backgroundColor:
                        pageNumber === currentPage ? "black" : "white",
                      color: pageNumber === currentPage ? "white" : "black",
                      border:
                        pageNumber === currentPage
                          ? "1px solid white"
                          : "1px solid black",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    {pageNumber}
                  </button>
                );
              })}

              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
                style={{
                  padding: "8px 16px",
                  margin: "0 5px",
                  backgroundColor: "white",
                  color: "black",
                  border: "1px solid black",
                  borderRadius: "4px",
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                  opacity: currentPage === totalPages ? 0.6 : 1,
                }}
              >
                Next
              </button>
            </div>
          ) : (
            ""
          )}
        </>
      )}

      {selectPlan !== "" ? (
        <Plans
          justCloseIt={() => setSelectPlan(false)}
          isModalOpen={selectPlan ? true : false}
        />
      ) : (
        ""
      )}

      {seletedFile !== "" ? (
        <DeleteFileModal
          isModalOpen={seletedFile ? true : false}
          yesDelete={deleteFile}
          justCloseIt={() => {
            setSeletedFile(false);
          }}
          fileInfo={seletedFile}
        />
      ) : (
        ""
      )}

      {openWebModal && (
        <NewAddWebsiteModal
          isOpen={openWebModal}
          onClose={handleWebModal}
          getuploadfiles={refreshFilesForActiveTab}
          isSharedKnowledge={activeKBTab === "Shared Knowledge"}
        />
      )}
    </div>
  );
}

export default Files;
